import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommandModalComponent } from './components/command-modal/command-modal.component';
import { FomanticUIModule } from 'ngx-fomantic-ui';
import { DynamicComponentModule } from '../dynamic-component/dynamic-component.module';

@NgModule({
  declarations: [CommandModalComponent],
  entryComponents: [CommandModalComponent],
  imports: [
    CommonModule,
    DynamicComponentModule,
    FomanticUIModule
  ],
  exports: [CommandModalComponent]
})
export class CommandModalModule { }
